export default __webpack_public_path__ + "static/media/521.5023dce2.gif";